// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1231":"22f5eebb","2033":"c3820bc6","6073":"22f5eebb"}[chunkId] + ".chunk.css";
};